export default __webpack_public_path__ + "static/media/addTemplate.398492a1.svg";